// @core/api/endpoints/authz/batch_check.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BatchCheckRequest,
  BatchCheckResponse,
} from '../../../types/authz';

const BASE_PATH = '/authz';

/**
 * Batch check authorization
 * Performs multiple authorization checks in a single request for improved efficiency. Supports up to 50 checks per request, reducing network overhead compared to individual Check calls.
 */
export async function BatchCheck(
  data: BatchCheckRequest,
  options?: RequestOptions
): Promise<BatchCheckResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/check/batch`;
  const requestOptions = options;
  return client.post<BatchCheckResponse>(requestPath, data, requestOptions);
}
